(function () {
  var cfg = window.BoraRobes || {};

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    var withComma = value.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var nav = document.querySelector('[data-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* Gallery */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-gallery-prev],[data-gallery-next]');
    if (arrow) {
      var g = arrow.closest('[data-gallery]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
      if (!thumbs.length) return;
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var step = arrow.hasAttribute('data-gallery-next') ? 1 : -1;
      var next = thumbs[(i + step + thumbs.length) % thumbs.length];
      next.click();
      next.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-main-image]');
    main.src = thumb.getAttribute('data-full');
    main.srcset = '';
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var section = form.closest('[data-section]') || document;

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var btn = form.querySelector('[data-add-button]');
      if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? btn.getAttribute('data-label') : 'Sold out';
      var cur = section.querySelector('[data-price-current]');
      var cmp = section.querySelector('[data-price-compare]');
      var badge = section.querySelector('[data-price-badge]');
      if (cur) cur.textContent = formatMoney(variant.price);
      if (cmp && badge) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          cmp.textContent = formatMoney(variant.compare_at_price);
          cmp.hidden = false;
          badge.textContent = 'SAVE ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
          badge.hidden = false;
          if (cur) cur.classList.add('price__current--sale');
        } else { cmp.hidden = true; badge.hidden = true; if (cur) cur.classList.remove('price__current--sale'); }
      }
      if (variant.featured_image) {
        var main = section.querySelector('[data-main-image]');
        if (main) { main.src = variant.featured_image.src; main.srcset = ''; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      btn.disabled = true;
      fetch(cfg.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer(); })
        .catch(function (err) { alert((err && err.description) || 'Could not add to cart. Please try again.'); })
        .finally(function () { btn.disabled = false; });
    });
  });

  /* Cart drawer */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) { window.location.href = cfg.routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var items = drawer.querySelector('[data-cart-items]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var ship = drawer.querySelector('[data-cart-shipping]');
    if (cart.item_count === 0) {
      items.innerHTML = '<p class="drawer__empty">Your cart is empty 💜</p>';
      foot.hidden = true;
    } else {
      foot.hidden = false;
      items.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="line__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
        return '<div class="line">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<span></span>') +
          '<div><div class="line__title">' + escapeHtml(item.product_title) + '</div>' + variant +
          '<div class="qty"><button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
          '<div class="line__price">' + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
      subtotal.textContent = formatMoney(cart.total_price);
    }
    if (ship) {
      var threshold = cfg.freeShippingThreshold || 0;
      if (threshold <= 0) { ship.hidden = true; }
      else {
        ship.hidden = false;
        var left = threshold - cart.total_price;
        ship.querySelector('[data-ship-text]').textContent = left > 0
          ? 'Spend ' + formatMoney(left) + ' more to get FREE shipping! 🚚'
          : 'You unlocked FREE shipping! 🎉';
        ship.querySelector('[data-ship-bar]').style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      }
    }
  }

  function refreshCart() {
    return fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    var q = e.target.closest('[data-qty]');
    if (q) {
      fetch(cfg.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: q.getAttribute('data-qty'), quantity: Number(q.getAttribute('data-to')) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Newsletter feedback */
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    var msg = document.querySelector('[data-newsletter-msg]');
    if (msg) { msg.hidden = false; }
  }
})();
